/** 當前版型 */
export const getCurrentScreenMode = (width: number, screens?: Window['__screens']) => {
  if (width < screens?.sm!) {
    return 'sm'
  } else if (width < screens?.md!) {
    return 'md'
  } else if (width < screens?.lg!) {
    return 'lg'
  } else if (width < screens?.xl!) {
    return 'xl'
  } else if (width < screens?.['2xl']!) {
    return '2xl'
  }
  return 'none'
}

/**
 * View Mode to Map
 * sm:sm,md:md,lg:lg,xl:xl,2xl:2xl = fontSize 各端等比各端
 * sm:sm,md:sm = fontSize sm 等比 sm, md 等比 sm, 其他固定 1
 */
export const createScreenRateMode = (mode: string, screens?: Window['__screens']) => {
  return String(mode)
    .split(',')
    .reduce((map, item) => {
      const [viewport, target] = item.split(':')
      map.set(viewport, screens?.[target as keyof typeof screens] || 0)
      return map
    }, new Map<string, number>([]))
}

type FontRate = number
type UpdateKey = string

/** 字體大小，需要針對不同版型做調整 */
export const computedFontSize = (screenRateMode: ReturnType<typeof createScreenRateMode>, width?: number, screens?: Window['__screens']): [FontRate, UpdateKey] => {
  // 服務端不執行 | 無寬度 | 無配置 screens | 無配置 view mode
  if (!width || !screens) return [1, 'none']
  // 無配置的都是 fontSize 1
  // const currentMode = getCurrentScreenMode(width, screens)
  // if (!screenRateMode.has(currentMode)) return [1, currentMode]
  // // 0 視為不縮放
  // const relative = screenRateMode.get(currentMode) || 0
  // if (relative === 0) return [1, currentMode]
  // 返回比例
  // return [width / relative, currentMode]
  if (width < 576) {
    return [width / 390, Date.now().toString()]
  }
  if (width < 1024) {
    return [width / 1024, Date.now().toString()]
  }
  return [1, Date.now().toString()]
}
